export default {
    items: [
        {
            name: 'Reports',
            type: 'report',
            route: 'dashboard',
            query: '',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
        },
        // {
        //     name: 'Content',
        //     children: [
        //         { name: 'Layouts', route: 'layouts', shortcut: 'layout/_' },
        //         { name: 'Pages', route: 'pages', type: 'page', shortcut: 'page/_' },
        //         { name: 'Panel library', route: 'panels', type: 'panel', shortcut: 'panel/_' },
        //         { name: 'Quick Links', route: 'quick_links', type: 'quick_link', shortcut: 'quick_link/_' },
        //     ],
        //     iconClass: 'material-icons',
        //     iconName: 'content_copy',
        //     color: 'navy',
        // },
        // {
        //     name: 'Assets',
        //     route: 'assets',
        //     type: 'asset',
        //     iconClass: 'material-icons',
        //     iconName: 'photo_album',
        //     color: 'navy',
        // },
        {
            name: 'Campaigns',
            route: 'campaigns',
            type: 'campaign',
            iconClass: 'material-icons',
            iconName: 'devices_other',
            color: 'navy',
        },
        {
            name: 'Contacts',
            type: 'contact',
            route: 'contacts',
            iconClass: 'material-icons',
            iconName: 'contacts',
            color: 'navy',
        },
        {
            name: 'Messages',
            route: 'messages',
            type: 'message',
            iconClass: 'material-icons',
            iconName: 'mail_outline',
            color: 'navy',
        },
        // {
        //     name: 'Enquiries',
        //     children: [
        //         { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
        //         { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
        //     ],
        //     iconClass: 'material-icons',
        //     iconName: 'forum',
        //     color: 'navy',
        // },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', shortcut: 'user/_', type: 'user' },
                { name: 'Roles', route: 'roles', shortcut: 'role/_', type: 'role' },
            ],
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Maintenance', route: 'setting/1#maintenance', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
        }
    ],
    defaultItem: 'Content',
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/menu.js